import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {Code} from "../../model/code";
import {CodeApiService} from "../../generated-sources/api/i18n";

@Injectable({
    providedIn: "root"
})
export class CodeService {
    private readonly codeApiService = inject(CodeApiService);

    constructor( ) {
    }

    getCodeTables(findByTable: string): Observable<Code[]> {
        return this.codeApiService.search(findByTable);
    }
}
